import { render, staticRenderFns } from "./AddUpdateCustomer.vue?vue&type=template&id=1d705b3f&"
import script from "./AddUpdateCustomer.vue?vue&type=script&lang=js&"
export * from "./AddUpdateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports